import { format } from '@sequencehq/utils/dates'

export function toApiDateTime(date: Date | string): string {
  return `${format(date, 'yyyy-MM-dd')}T00:00:00Z`
}
